<template>
  <div class="container">
    <div class="oferta-container padding-17-left-right">
      <wrap-container class="w100 grid-container grid-container--6-6">
        <wrap-container class="col1 main-title">
          <p id="titulo" class="titulo p28 oscuro hola">
            ¡Hola <span data-obfuscate>{{ nombre }}</span
            >!
          </p>
          <p id="subtitulo" class="titulo p32 oscuro medium tenemos">
            Tenemos estos beneficios para vos
          </p>
        </wrap-container>
      </wrap-container>
      <wrap-container class="cascade w50">
        <div class="oferta">
          <div class="card-container">
            <product-image-container
              class="card"
              :tarjetas="['visa-debito-nacional']"
              quantumObfuscate
            />
          </div>
          <p
            class="caja-de-ahorro"
            v-safe-html="config.pasos.ofertaCA.titulo"
          />
          <p
            class="cobra-tu-sueldo"
            v-safe-html="config.pasos.ofertaCA.subtitulo"
          />
          <premios-oferta-caja-ahorro />
          <sales-button
            class="sales-button"
            ref="salesbutton"
            :label="config.pasos.ofertaCA.botonSiguiente"
            @click.native="$router.push(config.pasos.ofertaCA.pasoSiguiente)"
          />
        </div>
      </wrap-container>
      <wrap-container class="cascade w50 margin-benefits-m">
        <offer-group
          class="content-bonus-items margin-bonus-m"
          label="Y te damos estos beneficios:"
        >
          <offer-element
            v-for="inc in ofertaCajaAhorro.beneficios"
            v-bind:key="inc.label"
            :label="inc.label"
            :description="inc.description"
            :linktitle="inc.linktitle"
            :linkpath="inc.linkpath"
          />
        </offer-group>
      </wrap-container>
      <div class="button-mobile">
        <sales-button
          class="sales-button"
          ref="salesbutton"
          :label="config.pasos.ofertaCA.botonSiguiente"
          @click.native="$router.push(config.pasos.ofertaCA.pasoSiguiente)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import OfferGroup from "@/components/core/OfferGroup";
import OfferElement from "@/components/core/OfferElement";
import SalesButton from "@/components/core/SalesButton";
import PremiosOfertaCajaAhorro from "@/components/core/custom/PremiosOfertaCajaAhorro";
import ofertaCajaAhorro from "@/config/constants/ofertaCajaAhorro";
import ProductImageContainer from "@/components/core/ProductImageContainer";

export default {
  name: "OfertaCA",
  components: {
    WrapContainer,
    OfferGroup,
    OfferElement,
    SalesButton,
    PremiosOfertaCajaAhorro,
    ProductImageContainer
  },
  computed: {
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    },
    ofertaCajaAhorro() {
      return ofertaCajaAhorro();
    }
  },
  mounted() {
    this.preloadSdk();
  }
};
</script>
<style scoped>
.content-bonus-items {
  margin-left: 17px;
}
.bonus-items {
  margin-top: 50px;
  padding-bottom: 20px;
}
div.container {
  height: 100%;
}

.oferta-container {
  max-width: 1200px;
  margin: 0 auto;
}

div.oferta {
  display: block;
  max-width: 550px;
  margin-bottom: 40px;
}

p {
  margin-top: 0px;
  margin-bottom: 0px;
}

p#subtitulo {
  margin-bottom: 37px;
}

.main-title {
  margin-bottom: -20px;
}

.caja-de-ahorro {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 26px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #666666;
  margin-top: 40px;
  margin-bottom: 16px;
}

.cobra-tu-sueldo {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: #666666;
  margin-bottom: 50px;
}

.middle-iwt {
  margin-left: 62px;
  margin-right: 62px;
}

.button-mobile {
  display: none;
}

.que-incluye {
  margin-bottom: 16px;
  margin-top: 0px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 15px;
  margin-left: 17px;
}

.sales-button {
  margin-bottom: 40px;
}

@media screen and (max-width: 599px) {
  #titulo {
    font-size: 20px;
  }
  #subtitulo {
    font-size: 26px;
  }
  .hola {
    text-align: center;
  }
  .tenemos {
    text-align: center;
    margin-top: 10px;
  }
  .caja-de-ahorro {
    text-align: center;
    line-height: 1.2;
    font-size: 20px;
    margin-top: 30px;
  }
  .cobra-tu-sueldo {
    text-align: center;
    font-size: 15px;
    margin-bottom: 40px;
  }
  .middle-iwt {
    margin-left: 0px;
    margin-right: 0px;
  }
  .card-container {
    margin: 0 auto;
    text-align: center;
  }
  .card {
    min-width: 149px;
    min-height: 94px;
  }
  .margin-benefits-m {
    margin-top: 32px;
  }

  .button-mobile {
    display: block;
    margin-bottom: 60px;
    margin-top: -25px;
  }
}
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .card-container {
    margin: 0 auto;
    text-align: center;
  }
  .hola {
    width: 200%;
    text-align: center;
  }
  .tenemos {
    width: 200%;
    text-align: center;
  }
  .caja-de-ahorro {
    text-align: center;
  }
  .cobra-tu-sueldo {
    text-align: center;
  }
  .sales-button {
    max-width: 100%;
  }
  .middle-iwt {
    margin-left: 0px;
    margin-right: 0px;
  }
}

@media screen and (min-width: 1025px) {
  .sales-button {
    max-width: 250px;
  }
}
</style>
